
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function OwnersBanner() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/tokyo-airbnb-support');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section
      className="relative py-8"
      style={{
        background: 'linear-gradient(135deg, #f5e6c8 0%, #ede0c4 100%)',
        fontFamily: "'Noto Serif JP', serif",
      }}
    >
      {/* 上部装飾ライン */}
      <div className="w-full h-1 flex overflow-hidden">
        {Array.from({ length: 80 }).map((_, i) => (
          <div
            key={i}
            className="flex-1 h-1"
            style={{ backgroundColor: i % 2 === 0 ? '#8B2500' : '#c8a96e' }}
          />
        ))}
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-center">
        <p className="text-xs mb-2" style={{ color: '#6b4c2a', letterSpacing: '0.1em' }}>
          {t('common:ownersBanner.subtitle')}
        </p>
        <button
          onClick={handleClick}
          className="group inline-flex items-center gap-2 text-sm transition-all duration-300 cursor-pointer hover:gap-3"
          style={{ color: '#8B2500' }}
        >
          <span className="border-b border-[#8B2500] group-hover:border-[#c8a96e]">
            {t('common:ownersBanner.linkText')}
          </span>
          <i className="ri-arrow-right-line text-base transition-transform duration-300 group-hover:translate-x-1"></i>
        </button>
      </div>

      {/* 下部装飾ライン */}
      <div className="w-full h-1 flex overflow-hidden">
        {Array.from({ length: 80 }).map((_, i) => (
          <div
            key={i}
            className="flex-1 h-1"
            style={{ backgroundColor: i % 2 === 0 ? '#c8a96e' : '#8B2500' }}
          />
        ))}
      </div>
    </section>
  );
}